import { render, staticRenderFns } from "./MessagingListCard.vue?vue&type=template&id=424fa650&scoped=true&"
import script from "./MessagingListCard.vue?vue&type=script&lang=js&"
export * from "./MessagingListCard.vue?vue&type=script&lang=js&"
import style0 from "./MessagingListCard.vue?vue&type=style&index=0&id=424fa650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424fa650",
  null
  
)

export default component.exports